import { style } from '@/styles/globals';
import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { ArroundNearMeIcon } from '../../../public/icons';
import { pr } from '@/utils/pxToRem';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const styleLocationTitle = {
  fontSize: '12px',
  lineHeight: '16px',
  color: style.color.black8,
  fontWeight: '500',
};
const YourLocation = ({ lang }: { lang?: ILangObj }) => (
  <Stack
    spacing={1}
    style={{
      margin: 0,
      marginBottom: pr`16px`,
    }}
  >
    <Typography
      variant="body1"
      sx={styleLocationTitle}
      paddingX="16px"
    >
      {lang?.SearchBar?.flightsTab?.yourLocation || 'VỊ TRÍ CỦA BẠN'}
    </Typography>
    <Stack
      spacing={1}
      direction="row"
      paddingX="16px"
    >
      <ArroundNearMeIcon />
      <Typography
        component="div"
        sx={{
          color: style.color.product3,
          fontWeight: 'bold',
          fontSize: 'inherit',
        }}
        variant="caption"
      >
        {lang?.SearchBar?.flightsTab?.currentLocation || 'Vị trí hiện tại'}
        <Typography
          component="div"
          variant="caption"
        >
          {lang?.SearchBar?.flightsTab?.accessLocation || 'Cho phép truy cập vị trí để chọn nhanh địa điểm'}
        </Typography>
      </Typography>
    </Stack>
  </Stack>
);

export default YourLocation;
